module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/teachers",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v("Aktivasi Guru")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f1d1050","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/Navigation.vue
// module id = 1298
// module chunks = 0